export default [
  {
    path: '/ticket',
    name: 'ticket',
    component: () => import('@/views/menu/ticket/ticket.vue'),
    meta: {
      pageTitle: 'مدیریت تیکت ها',
      action: 'show',
      resource: 'TicketManager',
    },
  },
  {
    path: '/ticket/details/:id',
    name: 'updateticket',
    component: () => import('@/views/menu/ticket/ticketdetails.vue'),
    meta: {
      pageTitle: 'ویرایش تیکت',
      action: 'show',
      resource: 'TicketManager',
    },
  },
  {
    path: '/ticketcategory',
    name: 'ticketcategory',
    component: () => import('@/views/menu/ticket/ticketcategory.vue'),
    meta: {
      pageTitle: 'مدیریت دپارتمان های تیکت',
      action: 'show',
      resource: 'TicketCategoryManager',
    },
  },
]
